import Api from './api.service'

export default {
  createGuideCard (object) {
    return Api().post('guideCard/create', object)
  },
  updateGuideCard (object) {
    return Api().put('guideCard/edit/' + object.id, object.object)
  },
  guideCardList (filter) {
    return Api().get('guideCard/get', { params: filter })
  },
  getGuideCard (id) {
    return Api().get('guideCard/get/' + id)
  },
  // skipGuideCard () {
  //   return Api().put('guideCard/skip')
  // },
}
